import { Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

export abstract class AbstractPlugin implements OnInit, OnDestroy {

    @Input() plugin: any;

    /**
     * The template reference where to render.
     */
    @ViewChild('content', {read: ViewContainerRef}) content: ViewContainerRef;

    /**
     * The observable to listen to data changes from the plugin slot.
     *
     * @type {Observable<any>}
     */
    @Input() private observable: Observable<any>;

    /**
     * The subscription used to listen to data changes.
     *Ω
     * @type {Subscription}
     */
    private $subscription: Subscription;

    /**
     * Indicates if the plugin data has been initialized.
     *
     * @type {boolean}
     */
    private $initialized = false;

    ngOnInit() {
        if (this['onInit'] && this['onInit'] instanceof Function) {
            this['onInit']();
        }

        if (this.observable) {
            this.$subscription = this.observable.subscribe((data) => {
                if (!this.$initialized) {
                    if (this['onDataInit'] && this['onDataInit'] instanceof Function) {
                        this['onDataInit'](data);
                    }
                }

                if (this['onDataChanges'] && this['onDataChanges'] instanceof Function) {
                    this['onDataChanges'](data);
                }

                this.$initialized = true;
            });
        }
    }

    ngOnDestroy() {
        if (this.$subscription) {
            this.$subscription.unsubscribe();
        }

        if (this['onDestroy'] && this['onDestroy'] instanceof Function) {
            this['onDestroy']();
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugin.component.ts